export { default } from './InputAdornment';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/InputAdornment/index.js
// module id = 160
// module chunks = 121